import { GatewayDeclarationActivite } from "@conformite/gateway";
import { userSession } from "@src/data/session/UserSession";

export class DeclarationActiviteApi {
  static async getIobspAdmin(
    siren: string,
    millesime: number
  ): Promise<GatewayDeclarationActivite.DeclarationActiviteIobsp | null> {
    const { data } =
      await userSession.axiosInstance.get<GatewayDeclarationActivite.DeclarationActiviteIobsp | null>(
        GatewayDeclarationActivite.declarationActiviteAdminUrl(
          siren,
          millesime,
          "iobsp"
        )
      );
    return data;
  }
}
